<div class="z-index">
    <app-dynamic-form class="w-fit" *ngIf="displayOptionForm " [formGroup]="displayOptionForm"
        [inputForm]="inputFormDisplay" [appearanceForm]="'fill'">
    </app-dynamic-form>
</div>